import { render } from "./ProProdutosTabelaPrecoView.vue?vue&type=template&id=2338fac2&scoped=true"
import script from "./ProProdutosTabelaPrecoView.vue?vue&type=script&lang=js"
export * from "./ProProdutosTabelaPrecoView.vue?vue&type=script&lang=js"

import "./ProProdutosTabelaPrecoView.vue?vue&type=style&index=0&id=2338fac2&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2338fac2"]])

export default __exports__